// Redux Action Type for List and CRUD creat read update delete for Tasks

// TaskCrmIt List
export const GET_TASKS_CRMIT_LIST = "GET_TASKS_CRMIT_LIST";
export const GET_TASKS_CRMIT_LIST_SUCCESS = "GET_TASKS_CRMIT_LIST_SUCCESS";
export const GET_TASKS_CRMIT_LIST_ERROR = "GET_TASKS_CRMIT_LIST_ERROR";

// TaskCrmIt Create
export const CREATE_TASK_CRMIT = "CREATE_TASK_CRMIT";
export const CREATE_TASK_CRMIT_SUCCESS = "CREATE_TASK_CRMIT_SUCCESS";
export const CREATE_TASK_CRMIT_ERROR = "CREATE_TASK_CRMIT_ERROR";

// TaskCrmIT Read
export const GET_TASK_CRMIT = "GET_TASK_CRMIT";
export const GET_TASK_CRMIT_SUCCESS = "GET_TASK_CRMIT_SUCCESS";
export const GET_TASK_CRMIT_ERROR = "GET_TASK_CRMIT_ERROR";

// TaskCrmIt Update

export const UPDATE_TASK_CRMIT = "UPDATE_TASK_CRMIT";
export const UPDATE_TASK_CRMIT_SUCCESS = "UPDATE_TASK_CRMIT_SUCCESS";
export const UPDATE_TASK_CRMIT_ERROR = "UPDATE_TASK_CRMIT_ERROR";

// TaskCrmIt Claim (member claims a pooled/team task)

export const CLAIM_TASK_CRMIT = "CLAIM_TASK_CRMIT";
export const CLAIM_TASK_CRMIT_SUCCESS = "CLAIM_TASK_CRMIT_SUCCESS";
export const CLAIM_TASK_CRMIT_ERROR = "CLAIM_TASK_CRMIT_ERROR";

// TaskCrmIt Delete

export const DELETE_TASK_CRMIT = "DELETE_TASK_CRMIT";
export const DELETE_TASK_CRMIT_SUCCESS = "DELETE_TASK_CRMIT_SUCCESS";
export const DELETE_TASK_CRMIT_ERROR = "DELETE_TASK_CRMIT_ERROR";

// Task Status List CRMIT

export const GET_TASK_STATUS_LIST_CRMIT = "GET_TASK_STATUS_LIST_CRMIT";
export const GET_TASK_STATUS_LIST_CRMIT_SUCCESS =
  "GET_TASK_STATUS_LIST_CRMIT_SUCCESS";
export const GET_TASK_STATUS_LIST_CRMIT_ERROR =
  "GET_TASK_STATUS_LIST_CRMIT_ERROR";

// Single Customer Task List
export const SEARCH_TASK_LIST = "SEARCH_TASK_LIST";
export const SEARCH_TASK_LIST_SUCCESS = "SEARCH_TASK_LIST_SUCCESS";
export const SEARCH_TASK_LIST_ERROR = "SEARCH_TASK_LIST_ERROR";

// Tasks Type Get List
export const GET_TASK_TYPE_LIST = "GET_TASK_TYPE_LIST";
export const GET_TASK_TYPE_LIST_SUCCESS = "GET_TASK_TYPE_LIST_SUCCESS";
export const GET_TASK_TYPE_LIST_ERROR = "GET_TASK_TYPE_LIST_ERROR";

// Task Priority List
export const GET_TASK_PRIORITY_LIST = "GET_TASK_PRIORITY_LIST";
export const GET_TASK_PRIORITY_LIST_SUCCESS = "GET_TASK_PRIORITY_LIST_SUCCESS";
export const GET_TASK_PRIORITY_LIST_ERROR = "GET_TASK_PRIORITY_LIST_ERROR";

// Single Task task Note Data
export const GET_SINGLE_TASK_NOTE_DATA = "GET_SINGLE_TASK_NOTE_DATA";
export const GET_SINGLE_TASK_NOTE_DATA_SUCCESS =
  "GET_SINGLE_TASK_NOTE_DATA_SUCCESS";
export const GET_SINGLE_TASK_NOTE_DATA_ERROR =
  "GET_SINGLE_TASK_NOTE_DATA_ERROR";

// Single Task Create Note
export const CREATE_SINGLE_TASK_NOTE = "CREATE_SINGLE_TASK_NOTE";
export const CREATE_SINGLE_TASK_NOTE_SUCCESS =
  "CREATE_SINGLE_TASK_NOTE_SUCCESS";
export const CREATE_SINGLE_TASK_NOTE_ERROR = "CREATE_SINGLE_TASK_NOTE_ERROR";

//singleJobTasksListForTimer
export const SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER =
  "SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER";
export const SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_SUCCESS =
  "SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_SUCCESS";
export const SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_ERROR =
  "SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_ERROR";

// Task Time Entry Search
export const SEARCH_TASK_TIME_ENTRY_LIST = "SEARCH_TASK_TIME_ENTRY_LIST";
export const SEARCH_TASK_TIME_ENTRY_LIST_SUCCESS =
  "SEARCH_TASK_TIME_ENTRY_LIST_SUCCESS";
export const SEARCH_TASK_TIME_ENTRY_LIST_ERROR =
  "SEARCH_TASK_TIME_ENTRY_LIST_ERROR";

// Task Time Entry Create
export const CREATE_TASK_TIME_ENTRY = "CREATE_TASK_TIME_ENTRY";
export const CREATE_TASK_TIME_ENTRY_SUCCESS = "CREATE_TASK_TIME_ENTRY_SUCCESS";
export const CREATE_TASK_TIME_ENTRY_ERROR = "CREATE_TASK_TIME_ENTRY_ERROR";

// Add New Task Status
export const ADD_NEW_TASK_STATUS = "ADD_NEW_TASK_STATUS";
export const ADD_NEW_TASK_STATUS_SUCCESS = "ADD_NEW_TASK_STATUS_SUCCESS";
export const ADD_NEW_TASK_STATUS_ERROR = "ADD_NEW_TASK_STATUS_ERROR";

// Update Task Status
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS";
export const UPDATE_TASK_STATUS_SUCCESS = "UPDATE_TASK_STATUS_SUCCESS";
export const UPDATE_TASK_STATUS_ERROR = "UPDATE_TASK_STATUS_ERROR";

// Delete Task Status

export const DELETE_TASK_STATUS = "DELETE_TASK_STATUS";
export const DELETE_TASK_STATUS_SUCCESS = "DELETE_TASK_STATUS_SUCCESS";
export const DELETE_TASK_STATUS_ERROR = "DELETE_TASK_STATUS_ERROR";

// Add New Task Type
export const ADD_NEW_TASK_TYPE = "ADD_NEW_TASK_TYPE";
export const ADD_NEW_TASK_TYPE_SUCCESS = "ADD_NEW_TASK_TYPE_SUCCESS";
export const ADD_NEW_TASK_TYPE_ERROR = "ADD_NEW_TASK_TYPE_ERROR";

// Update Task Type
export const UPDATE_TASK_TYPE = "UPDATE_TASK_TYPE";
export const UPDATE_TASK_TYPE_SUCCESS = "UPDATE_TASK_TYPE_SUCCESS";
export const UPDATE_TASK_TYPE_ERROR = "UPDATE_TASK_TYPE_ERROR";

// Delete Task Type

export const DELETE_TASK_TYPE = "DELETE_TASK_TYPE";
export const DELETE_TASK_TYPE_SUCCESS = "DELETE_TASK_TYPE_SUCCESS";
export const DELETE_TASK_TYPE_ERROR = "DELETE_TASK_TYPE_ERROR";

// Add New Task Priority
export const ADD_NEW_TASK_PRIORITY = "ADD_NEW_TASK_PRIORITY";
export const ADD_NEW_TASK_PRIORITY_SUCCESS = "ADD_NEW_TASK_PRIORITY_SUCCESS";
export const ADD_NEW_TASK_PRIORITY_ERROR = "ADD_NEW_TASK_PRIORITY_ERROR";

// Update Task Priority
export const UPDATE_TASK_PRIORITY = "UPDATE_TASK_PRIORITY";
export const UPDATE_TASK_PRIORITY_SUCCESS = "UPDATE_TASK_PRIORITY_SUCCESS";
export const UPDATE_TASK_PRIORITY_ERROR = "UPDATE_TASK_PRIORITY_ERROR";

// Delete Task Priority

export const DELETE_TASK_PRIORITY = "DELETE_TASK_PRIORITY";
export const DELETE_TASK_PRIORITY_SUCCESS = "DELETE_TASK_PRIORITY_SUCCESS";
export const DELETE_TASK_PRIORITY_ERROR = "DELETE_TASK_PRIORITY_ERROR";

// Get Task Recent Activity List
export const GET_TASK_RECENT_ACTIVITY_LIST = "GET_TASK_RECENT_ACTIVITY_LIST";
export const GET_TASK_RECENT_ACTIVITY_LIST_SUCCESS =
  "GET_TASK_RECENT_ACTIVITY_LIST_SUCCESS";
export const GET_TASK_RECENT_ACTIVITY_LIST_ERROR =
  "GET_TASK_RECENT_ACTIVITY_LIST_ERROR";

// Get Task Change Log List (field-level change history)
export const GET_TASK_CHANGE_LOG_LIST = "GET_TASK_CHANGE_LOG_LIST";
export const GET_TASK_CHANGE_LOG_LIST_SUCCESS =
  "GET_TASK_CHANGE_LOG_LIST_SUCCESS";
export const GET_TASK_CHANGE_LOG_LIST_ERROR = "GET_TASK_CHANGE_LOG_LIST_ERROR";

///tasktemplate/list
export const GET_TASK_TEMPLATE_LIST = "GET_TASK_TEMPLATE_LIST";
export const GET_TASK_TEMPLATE_LIST_SUCCESS = "GET_TASK_TEMPLATE_LIST_SUCCESS";
export const GET_TASK_TEMPLATE_LIST_ERROR = "GET_TASK_TEMPLATE_LIST_ERROR";

///tasktemplate/data/
export const GET_TASK_TEMPLATE_DATA = "GET_TASK_TEMPLATE_DATA";
export const GET_TASK_TEMPLATE_DATA_SUCCESS = "GET_TASK_TEMPLATE_DATA_SUCCESS";
export const GET_TASK_TEMPLATE_DATA_ERROR = "GET_TASK_TEMPLATE_DATA_ERROR";

///tasktemplate/create
export const CREATE_TASK_TEMPLATE = "CREATE_TASK_TEMPLATE";
export const CREATE_TASK_TEMPLATE_SUCCESS = "CREATE_TASK_TEMPLATE_SUCCESS";
export const CREATE_TASK_TEMPLATE_ERROR = "CREATE_TASK_TEMPLATE_ERROR";

///tasktemplate/update
export const UPDATE_TASK_TEMPLATE = "UPDATE_TASK_TEMPLATE";
export const UPDATE_TASK_TEMPLATE_SUCCESS = "UPDATE_TASK_TEMPLATE_SUCCESS";
export const UPDATE_TASK_TEMPLATE_ERROR = "UPDATE_TASK_TEMPLATE_ERROR";

///tasktemplate/delete
export const DELETE_TASK_TEMPLATE = "DELETE_TASK_TEMPLATE";
export const DELETE_TASK_TEMPLATE_SUCCESS = "DELETE_TASK_TEMPLATE_SUCCESS";
export const DELETE_TASK_TEMPLATE_ERROR = "DELETE_TASK_TEMPLATE_ERROR";
///tasktemplate/search
export const SEARCH_TASK_TEMPLATE_LIST = "SEARCH_TASK_TEMPLATE_LIST";
export const SEARCH_TASK_TEMPLATE_LIST_SUCCESS =
  "SEARCH_TASK_TEMPLATE_LIST_SUCCESS";
export const SEARCH_TASK_TEMPLATE_LIST_ERROR =
  "SEARCH_TASK_TEMPLATE_LIST_ERROR";
///taskattachment/list
export const GET_TASK_ATTACHMENT_LIST = "GET_TASK_ATTACHMENT_LIST";
export const GET_TASK_ATTACHMENT_LIST_SUCCESS =
  "GET_TASK_ATTACHMENT_LIST_SUCCESS";
export const GET_TASK_ATTACHMENT_LIST_ERROR = "GET_TASK_ATTACHMENT_LIST_ERROR";
///taskattachment/search
export const SEARCH_TASK_ATTACHMENT_LIST = "SEARCH_TASK_ATTACHMENT_LIST";
export const SEARCH_TASK_ATTACHMENT_LIST_SUCCESS =
  "SEARCH_TASK_ATTACHMENT_LIST_SUCCESS";
export const SEARCH_TASK_ATTACHMENT_LIST_ERROR =
  "SEARCH_TASK_ATTACHMENT_LIST_ERROR";
///taskattachment/data
export const GET_TASK_ATTACHMENT_DATA = "GET_TASK_ATTACHMENT_DATA";
export const GET_TASK_ATTACHMENT_DATA_SUCCESS =
  "GET_TASK_ATTACHMENT_DATA_SUCCESS";
export const GET_TASK_ATTACHMENT_DATA_ERROR = "GET_TASK_ATTACHMENT_DATA_ERROR";
///taskattachment/delete
export const DELETE_TASK_ATTACHMENT = "DELETE_TASK_ATTACHMENT";
export const DELETE_TASK_ATTACHMENT_SUCCESS = "DELETE_TASK_ATTACHMENT_SUCCESS";
export const DELETE_TASK_ATTACHMENT_ERROR = "DELETE_TASK_ATTACHMENT_ERROR";
//taskUseHeartBeatLocally
export const TASK_USE_HEART_BEAT_LOCALLY = "TASK_USE_HEART_BEAT_LOCALLY";
export const TASK_USE_HEART_BEAT_LOCALLY_SUCCESS =
  "TASK_USE_HEART_BEAT_LOCALLY_SUCCESS";
export const TASK_USE_HEART_BEAT_LOCALLY_ERROR =
  "TASK_USE_HEART_BEAT_LOCALLY_ERROR";
